<template>
	<div id="app">
		<navbar v-if="$route.meta && !$route.meta.noNavBar"/>
		<router-view/>

		<!-- Demo Mode -->
		<div class="demo-mode__label" :class="{'demo-mode__label-on': demoMode}" id="dummyMode" v-if="demoMode && $route.meta && !$route.meta.noNavBar" v-on:click.prevent="$router.push('/settings/demo-mode')">You are in demo mode<span>Click here to activate<br/>live mode</span></div>
    <loadexternals v-if="$route.meta && $route.meta.bypassExternals !== true"/>
	</div>
</template>

<script>
import navbar from '@/components/navbar';
import loadexternals from '@/components/loadExternals';

export default {
	name: 'app',
	components: { navbar, loadexternals },
	computed: {
		demoMode: function() {
 		  return this.$store.getters.demoMode;
 	  }
  }
}
</script>

<style src="./styles/style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue